UPLOADCARE_LOCALE_TRANSLATIONS = {
  errors: {
    fileMinimalSize: "Total File size is too small",
    fileMaximumSize: "Total File size is too large",
  },
  dialog: {
    tabs: {
      preview: {
        error: {
          fileMinimalSize: {
            title: "Title.",
            text: "Text.",
            back: "Back",
          },
          fileMaximumSize: {
            title: "Title.",
            text: "Text.",
            back: "Back",
          },
        },
      },
    },
  },
};
function fileSizeLimit(min, max) {
  return function (fileInfo) {
    if (fileInfo.size === null) {
      return;
    }
    if (min && fileInfo.size < min) {
      throw new Error("fileMinimalSize");
    }
    if (max && fileInfo.size > max) {
      throw new Error("fileMaximumSize");
    }
  };
}

var widget = uploadcare.MultipleWidget("[role=uploadcare-uploader]", {
  publicKey: UPLOADCARE_PUBLIC_KEY,
  imagesOnly: true,
});

// var widget = uploadcare.Widget("#uploader", {
//   publicKey: UPLOADCARE_PUBLIC_KEY,
//   imagesOnly: true,
// });
widget.validators.push(
  fileSizeLimit(jQuery("#uploader").data("minSize"), jQuery("#uploader").data("maxSize"))
);
widget.onChange(function (group) {
  jQuery("#choosen-images").val("");
  jQuery("#uploader-div").empty();
  group.files().forEach((file) => {
    file.done(function (fileInfo) {
      console.log(">>>>>", fileInfo.cdnUrl + fileInfo.name);
      var imageElement = jQuery("<img>").attr("src", fileInfo.cdnUrl + fileInfo.name);
      imageElement.css({
        width: "100px",
        height: "100px",
        margin: "5px",
      });
      jQuery("#uploader-div").append(imageElement);
      var existingFileName = jQuery("#choosen-images").val();
      jQuery("#choosen-images").val(
        existingFileName.concat(",", fileInfo.cdnUrl + fileInfo.name)
      );
      console.log(">>>>>", fileInfo.cdnUrl + fileInfo.name, imageElement, existingFileName);
    });
  });
});

// --------------------------

jQuery(document).ready(function() {
  var imageUrlsInput = jQuery('input[role="uploadcare-uploader"]');
  var imageListDiv = jQuery('#displayImagelist');

  imageUrlsInput.on('input', function() {
    var inputText = jQuery(this).val();
    var parts = inputText.split('~');
    if (parts.length !== 2) {
      // Invalid input format
      return;
    }
    var numberOfImages = parseInt(parts[1].trim(), 10);
    if (isNaN(numberOfImages)) {
      // Invalid number of images
      return;
    }
    
    imageListDiv.empty();
    for (let i = 0; i < numberOfImages; i++) {
      var imageUrl = inputText + '/nth/' + i + '/';
      var img = jQuery('<img>').attr('src', imageUrl);
      imageListDiv.append($img);
    }
  });
});